import { apiFetch } from '@/lib/api';
import type {
  ConfigResponse,
  GoldListResponse,
  ProcNamesResponse,
  ResultsResponse,
  RunModel,
  SyncStatus,
  RunStatus,
} from './types';

const BASE = '/api/encounter-benchmarks';

export const encounterBenchmarkConfigApi = {
  get: (): Promise<ConfigResponse> => apiFetch<ConfigResponse>('/api/encounter-benchmark-config'),
};

export interface SyncParams {
  clientId: string;
  locationId?: string;
  status?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  pageSize?: number;
}
export interface RunParams {
  clientId: string;
  locationId?: string;
  onlyUnrun?: boolean;
  limit?: number;
  goldIds?: number[]; // targeted re-run: only these encounter rows
  model?: RunModel;
}

export const encounterBenchmarkApi = {
  results: (clientId: string, opts?: { page?: number; pageSize?: number }): Promise<ResultsResponse> =>
    apiFetch<ResultsResponse>(
      `${BASE}/results?clientId=${encodeURIComponent(clientId)}` +
        (opts?.page != null ? `&page=${opts.page}` : '') +
        (opts?.pageSize != null ? `&pageSize=${opts.pageSize}` : ''),
    ),

  gold: (clientId: string): Promise<GoldListResponse> =>
    apiFetch<GoldListResponse>(`${BASE}/gold?clientId=${encodeURIComponent(clientId)}`),

  sync: (p: SyncParams): Promise<{ started: boolean }> =>
    apiFetch<{ started: boolean }>(`${BASE}/sync`, { method: 'POST', body: JSON.stringify(p) }),

  syncStatus: (clientId: string): Promise<SyncStatus> =>
    apiFetch<SyncStatus>(`${BASE}/sync-status?clientId=${encodeURIComponent(clientId)}`),

  run: (p: RunParams): Promise<{ started: boolean }> =>
    apiFetch<{ started: boolean }>(`${BASE}/run`, { method: 'POST', body: JSON.stringify(p) }),

  runStatus: (clientId: string): Promise<RunStatus> =>
    apiFetch<RunStatus>(`${BASE}/run-status?clientId=${encodeURIComponent(clientId)}`),

  procNames: (clientId: string, locationId?: string): Promise<ProcNamesResponse> =>
    apiFetch<ProcNamesResponse>(
      `${BASE}/proc-names?clientId=${encodeURIComponent(clientId)}` +
        (locationId ? `&locationId=${encodeURIComponent(locationId)}` : ''),
    ),

  /** Same-origin GET — the admin session cookie authorizes it (no CSRF for <img>). */
  reqsheetUrl: (goldId: number): string => `${BASE}/gold/${goldId}/reqsheet`,

  /** The Nth reqsheet file (Case B multi-requisition encounters). */
  reqsheetUrlAt: (goldId: number, idx: number): string => `${BASE}/gold/${goldId}/reqsheet/${idx}`,
};
